import type {Textbox} from '@postermywall/fabricjs-2';

/**
 * The local-unit distance from the textbox's top edge to the top of visual line `lineIndex`: the
 * heights of every line above it, summed. Lines are not uniform once style runs can size a
 * selection (a run with a larger font makes its line taller), so `lineIndex × thisLineHeight`
 * placed the popup thirteen TALL lines down for a word on line 13 (reported 2026-10-12).
 */
export const getTextboxLineTopOffset = (target: Pick<Textbox, 'getHeightOfLine'>, lineIndex: number): number => {
  let offset = 0;
  for (let line = 0; line < lineIndex; line++) {
    offset += target.getHeightOfLine(line);
  }
  return offset;
};
